import React from "react";
import { observer } from "mobx-react";
import { OfferColumnConfigurationResult } from "@gp/components";
import { EventOffer } from "..";
import EmptyOfferColumns from "../EmptyOfferColumns";

export const EventOfferWrapper = observer(function EventOfferWrapper(props: {
	mainColumns: OfferColumnConfigurationResult | null;
}) {
	const { mainColumns } = props;

	if (mainColumns == null || mainColumns.isEmpty) {
		return <EmptyOfferColumns />;
	}

	return <EventOffer columns={mainColumns} />;
});
